import React, { Component } from 'react';
import { Gateway } from '../BaseUrl';
import { Input } from './Input';
import { Button } from './Button';
import queryString from 'query-string';
import { ForgotPassword } from './ForgotPassword';
import { Form } from './Form';

export class ResetPassword extends Component {
    constructor(props) {
        super(props);

        const values = queryString.parse(this.props.location.search)
        this.state = {
            resetToken: values.token,
            isValid: false,
            loadingAjax: false,
            sent: false,
            currentPassword: "",
            test: "",
            newPassword: "",
            confirmPassword: "",
            isCurrentValid: true,
            isNewPasswordValid: true,
            isConfirmValid: true
        }
                
        this.changePassword = this.changePassword.bind(this);
        this.ValidateToken = this.ValidateToken.bind(this);
        if (values.token != null) {
            this.ValidateToken();
        }        
        this.newPass = React.createRef();
        this.ConfPass = React.createRef();
    }
    
    ValidateToken() {
        fetch(Gateway + '/validate', {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.state.resetToken
            }
        }).then(response => {
            if (response.ok) {
                return response.text();
            } else {
                throw Error(response.status + ": " + response.statusText);
            }
        }).then(data => {
            this.setState({
                isValid: true,
                loading: false
            });
        }).catch((e) => {
            console.log("error", e); this.setState({
                isValid: false,
                loading: false
            });
        });
    }

    changePassword() {
        var { isConfirmValid, isCurrentValid, isNewPasswordValid } = this.state;

        if (isConfirmValid && isCurrentValid && isNewPasswordValid) {

            this.setState({
                loadingAjax: true
            });

            fetch(Gateway + '/password/set', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.state.resetToken
                },
                body: JSON.stringify({
                    Password: this.state.newPassword
                })
            }).then(response => {
                if (response.ok) {
                    return response.text();
                } else {
                    throw Error(response.status);
                }
            }).then(data => {                
                this.setState({
                    loadingAjax: false,
                    sent: true
                });
            }).catch((e) => {
                console.log("error", e);
                this.setState({
                    loadingAjax: false
                });
            });
        } 
    }

    render() {
        const title = this.props.isSignUp ? "Welcome to amigo loans" : "Reset Password";
        const expTitle = this.props.isSignUp ? "This sign up page is no longer available" : "This reset link has expired or is not valid";
        const expSubTitle = "Don't worry, just enter in your email address below to reset your password. Once your password is reset, you'll be able to log into your account.";
        
        return (
                    this.state.isValid ?
                        <div style={{ width: "100%" }}>
                        <div className="page-container" >
                                {this.state.sent ?
                                    <div style={{ textAlign: "center" }}>
                                        <h2>Your new password has been set</h2>
                                        <p>You can now login with your new password</p>
                                        <Button value="Login" onClick={() => this.props.history.push("/login")}/>
                                    </div> :
                                    <Form onSubmit={() => this.changePassword()}>
                                        <h2 className="text-center"> {title} </h2>
                                        <p>
                                            Enter a new password in the form below.
                                        </p>
                                        <Input
                                            ref={this.newPass}
                                            placeholder="New password"
                                            type="password"
                                            required={true}
                                            rules={[
                                                'minLength',
                                                'AplhaNumberic',
                                                'containNumber',
                                                'containUpperCase',
                                                'repeatingChars'
                                            ]}
                                            isValid={(e) => this.setState({ isNewPasswordValid: e })}
                                            className="form-control"
                                            value={this.state.newPassword}
                                            onChange={(e) => this.setState({ newPassword: e.target.value })}
                                        />
                                        <Input placeholder="Confirm new password"
                                            type="password"
                                            ref={this.ConfPass}
                                            required={true}
                                            matchString={true}
                                            matchMessage="Password's don't match"
                                            stringToMatch={this.state.newPassword}
                                            isValid={(e) => this.setState({ isConfirmValid: e })}
                                            className="form-control"
                                            value={this.state.confirmPassword}
                                            onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                                        />
                                        <Button type="submit" loading={this.state.loadingAjax} />
                                    </Form>
                                }
                            </div>
                        </div>
                        :
                        <div className="container" style={{ textAlign: "center" }}>                            
                            <ForgotPassword {...this.props} >
                                <h2>{expTitle}</h2>
                                <p>{expSubTitle}</p>
                            </ForgotPassword>
                    </div>
        );
    }
}

ResetPassword.defaultProps = {
    isSignUp: false
}


// WEBPACK FOOTER //
// ./src/components/resetPassword.js